import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
    name : 'user',
    initialState : {
        name : 'asdf;lka',
        route : '',
        State : '',
        expiryDay : 30
    },
    reducers : {
        setName : ( state, action ) => {
            state.name = action.payload
        },
        setRoute : ( state,action) => {
            state.route = action.payload
        },
        setState : ( state,action) => {
            state.State = action.payload
        },
        setExpiryDay : ( state,action) => {
            state.expiryDay = action.payload
        }
    }
})

export const { setName, setRoute, setState,setExpiryDay } = userSlice.actions

export default userSlice.reducer